
























































// @ts-nocheck
import { ValidationProvider } from "vee-validate";
import { Component, Vue, Prop, Emit, Watch, Ref } from "vue-property-decorator";
var Netmask = require("netmask").Netmask;

@Component({
  components: {
    ValidationProvider,
  },
})
export default class FormIpInput extends Vue {
  @Prop() name?: string;

  @Prop({ default: "" }) value?: string | number;

  @Prop({ default: "" }) ip?: string;

  @Prop() placeholder?: string;

  @Prop() rules?: string | object;

  @Prop() label?: string;

  @Prop({ default: true }) showError?: boolean;

  @Prop({ default: false }) disabled!: boolean;

  @Prop({ default: "text" }) type!: string;

  @Prop({ default: false }) autoFocus!: boolean;

  @Prop({ default: "text-14" }) labelClass!: string;

  @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

  isFocussed = false;

  localValue = "";

  validAtleastOnce = false;

  segments = ["", "", "", ""];

  private mounted() {
    if (this.autoFocus) {
      this.input.focus();
    }

    let val = this.value;
    if (typeof val === "number") {
      var block = new Netmask(`${this.ip}/${val}`);
      val = block.mask;
    }
    this.syncIp(val);
    this.$watch(
      () => {
        return this.segments.join(".");
      },
      (val, oldValue) => {
        if (val !== oldValue) {
          if (val === "...") {
            val = "";
          }
          if (this.onChange) {
            this.onChange(val);
          }
        }
      },
    );
  }

  private get formValdiated(): boolean {
    return this.provider.$_veeObserver?.flags?.validated;
  }

  private get validateAs(): string {
    if (this.label) {
      return this.label;
    }

    if (this.placeholder) {
      return this.placeholder;
    }

    if (this.name) {
      return this.name;
    }

    return `${this.type} field`;
  }

  private eagerIfDirty(_a: { flags: any; errors: any }) {
    var errors = _a.errors;
    var flags = _a.flags;
    if (errors.length) {
      return {
        on: ["input", "change"],
      };
    }

    if (flags.valid && !this.validAtleastOnce) {
      this.validAtleastOnce = true;
    }

    if (flags.dirty) {
      return {
        on: ["change", "blur", "input"],
      };
    }

    return {
      on: ["change"],
    };
  }

  private onInputKeydown(event, index) {
    var keyCode = event.keyCode || event.which;
    var value = event.target.value;

    if (keyCode === 8 || keyCode === 37) {
      // move the cursor to previous input if backspace and left arrow is pressed at the begin of one input
      if ((value.length === 0 || this.getRange(event.target).end === 0) && index > 0) {
        this.$el.getElementsByTagName("input")[index - 1].focus();
        // When jump to pre input(enter "backspace"), thr cursor should in the end.
        // before fix: 127.|0.0.0  =>   12|7.0.0.1
        // after fix: 127.|0.0.0 = >   127|.0.0.0
        // notes: "|" mean the cursor position.
        event.preventDefault();
      }
    } else if (keyCode === 39) {
      if (this.getRange(event.target).end === value.length && index < 3) {
        // move to cursor to the next input if right arrow is pressed at the end of one input
        this.$el.getElementsByTagName("input")[index + 1].focus();
      }
    }
  }

  private onInput(event, index) {
    var value = event.target.value;
    event.target.value = this.segments[index];

    var segment = Number(value);
    if (isNaN(segment)) {
      return;
    } else if (value === "") {
      this.segments.splice(index, 1, "");
    } else if (segment > 255 || segment < 0) {
      // set the segment to 255 if out of ip range
      this.segments.splice(index, 1, 255);
    } else {
      this.segments.splice(index, 1, segment);
    }
    // jump to next input
    if ((value.length === 3 && index < 3) || value[value.length - 1] === ".") {
      this.$el.getElementsByTagName("input")[index + 1].focus();
    }

    this.setLocalValue();
  }

  private onInputBlur() {
    setTimeout(() => {
      var className = document.activeElement.className;
      if (className.indexOf("ip-segment-input") === -1) {
        if (this.onBlur) {
          this.onBlur(this.segments.join("."));
        }
      }
    }, 50);
  }

  private onPaste(e, index) {
    var pasteText = e.clipboardData.getData("text/plain");
    var segments = pasteText.split(".");
    segments.forEach((segment, i) => {
      if (index + i < 4 && !isNaN(segment) && segment >= 0 && segment <= 255) {
        this.segments.splice(index + i, 1, segment);
      }
    });
    e.preventDefault();
  }

  private syncIp(ip: string) {
    if (ip && ip.indexOf(".") !== -1) {
      ip.split(".").map((segment, index) => {
        if (isNaN(segment) || segment < 0 || segment > 255) {
          segment = 255;
        }
        this.segments.splice(index, 1, segment);
        return segment;
      });
    }
  }

  private setLocalValue() {
    this.localValue = this.segments.join(".");
    this.$emit("input", this.localValue);
  }

  private getRange(el) {
    var cuRange;
    var tbRange;
    var headRange;
    var range;
    var dupRange;
    var ret = {};
    if (el.setSelectionRange) {
      // standard
      ret.begin = el.selectionStart;
      ret.end = el.selectionEnd;
      ret.result = el.value.substring(ret.begin, ret.end);
    } else if (document.selection) {
      // ie
      if (el.tagName.toLowerCase() === "input") {
        cuRange = document.selection.createRange();
        tbRange = el.createTextRange();
        tbRange.collapse(true);
        tbRange.select();
        headRange = document.selection.createRange();
        headRange.setEndPoint("EndToEnd", cuRange);
        ret.begin = headRange.text.length - cuRange.text.length;
        ret.end = headRange.text.length;
        ret.result = cuRange.text;
        cuRange.select();
      } else if (el.tagName.toLowerCase() === "textarea") {
        range = document.selection.createRange();
        dupRange = range.duplicate();
        dupRange.moveToElementText(el);
        dupRange.setEndPoint("EndToEnd", range);
        ret.begin = dupRange.text.length - range.text.length;
        ret.end = dupRange.text.length;
        ret.result = range.text;
      }
    }
    el.focus();
    return ret;
  }

  @Watch("value")
  private ipChanged(ip: string | number) {
    let val = this.value;

    if (typeof val === "number") {
      val = this.$root.int_to_ip(val);
    }
    this.syncIp(val);
  }
}
